import { NotificationManager } from "react-notifications";
import { getData } from "./apiService";
export async function getReport(params){
    let response=await getData("visits/report",params);
    if (response.success){
        return response.data;
    }
    NotificationManager.error(response.message);
    return false;
}